import styled from 'styled-components';
import { black4 } from '../../../common/colorConstants';

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: ${black4};
`;

export const ReasonContainer = styled.div`
  padding: 32px;
  flex-grow: 1;
`;

export const BlankReasonContainer = ReasonContainer;
